import { Tooltip } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import { SpokeStatusDto } from "./SpokeStatusDto";

type HubToSpokeProps = {

    spokeStatus : SpokeStatusDto

};


export const HubToSpoke : React.FC<HubToSpokeProps> = ( { spokeStatus } ) => {

    const hubToSpokeError = `lastStatusFromSpoke: ${spokeStatus.lstStatusFromSpoke} \n lastResponseMsgFromSpoke: ${spokeStatus.lastResponseMsgFromSpoke}`;

    const hubToSpokeDisplayColor = spokeStatus.hubToSpokeStatus === 'SUCCESS' ? 'green' : 'red';
    const spokeToHubDisplayColor = spokeStatus.spokeToHubStatus === 'SUCCESS' ? 'green' : 'red';

    const hubToSpokeStatusElement = spokeStatus.hubToSpokeStatus === 'SUCCESS' 
        ?
    <span style={{ fontWeight: 'bold', color: hubToSpokeDisplayColor }}>
        { spokeStatus.hubToSpokeStatus }
    </span>
        :
    <>
        <span style={{ fontWeight: 'bold', color: hubToSpokeDisplayColor }}>
            { spokeStatus.hubToSpokeStatus }
        </span>

        <Tooltip
            arrow
            title={ <div style={{ whiteSpace: 'pre-line' }}> {hubToSpokeError} </div> }
        >
            <InfoIcon sx={{color: 'red', cursor: 'pointer'}} />
        </Tooltip>
    </>;


    return (

        <>

            <h2 style={{ textAlign: 'center' }}>Hub-Spoke Connection</h2>

            <table style={{ height: 300, marginLeft: 'auto', marginRight: 'auto' }} cellSpacing={0} cellPadding={0}>
                <tbody>
                    <tr>
                        <td rowSpan={5}>

                            <div style={{height: '100%', width: 300, border: '2px solid #c4c4c4', borderRadius: 5, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: 20 }}>
                                Hub
                            </div>

                        </td>
                        <td style={{textAlign: 'center', verticalAlign: 'bottom', width: 100 }}>
                            
                            {hubToSpokeStatusElement}

                        </td>
                        <td rowSpan={5}>
                            <div style={{height: '100%', width: 300, border: '2px solid #c4c4c4', borderRadius: 5, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: 20 }}>Spoke</div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{textAlign: 'center', verticalAlign: 'middle', height: 20 }}>
                            
                            <svg height={20} width={100}>
                                <line x1="0" y1="10" x2="100" y2="10" stroke={hubToSpokeDisplayColor} strokeWidth={2} />
                                <line x1="90" y1="5" x2="100" y2="10" stroke={hubToSpokeDisplayColor} strokeWidth={2} />
                                <line x1="90" y1="15" x2="100" y2="10" stroke={hubToSpokeDisplayColor} strokeWidth={2} />
                            </svg>

                        </td>
                    </tr>
                    <tr>

                        <td style={{textAlign: 'center', verticalAlign: 'bottom'  }}>
                            
                            <span style={{ fontWeight: 'bold', color: spokeToHubDisplayColor }}>
                                { spokeStatus.spokeToHubStatus ?? 'Undefined' }
                            </span>

                        </td>

                    </tr>
                    <tr>
                        
                        <td style={{textAlign: 'center', verticalAlign: 'middle', height: 20 }}>
                            
                            <svg height={20} width={100}>

                                <line x1="0" y1="10" x2="100" y2="10" stroke={spokeToHubDisplayColor} strokeWidth={2} />
                                <line x1="0" y1="10" x2="10" y2="5" stroke={spokeToHubDisplayColor} strokeWidth={2} />
                                <line x1="0" y1="10" x2="10" y2="15" stroke={spokeToHubDisplayColor} strokeWidth={2} />

                            </svg>

                        </td>

                    </tr>
                    <tr>

                        <td style={{textAlign: 'center', verticalAlign: 'middle' }}>

                            &nbsp;

                        </td>

                    </tr>
                </tbody>
            </table>

        </>


    );


};